module.exports = __webpack_public_path__ + "img/al.46612c27.svg";